import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, ProgressBar } from 'react-bootstrap';
import { queueRendererJob } from '../utils/zoomServices';
import { projectMetadataSelector } from '../reducers/selectors';
import { useTranslation, Trans } from 'react-i18next';
import styles from './CompleteProject.less';
import PicabooLink from './PicabooLink';
import { blurbyProjectsBase } from '../config';
import invariant from 'tiny-invariant';
import {
  emitRenderFailedEvent,
  emitUploadFailedEvent,
} from '../utils/ct-events';
import { logCustomEvent } from '../utils/TagManager';

const CompleteProject = ({ messages, projectMeta, close, useLogo }) => {
  const { t } = useTranslation();
  let [renderJobPK, setRenderJob] = useState();
  let [donePercent, setDonePercent] = useState(0);
  let [addToCartURL, setAddToCartURL] = useState();
  let jobMessages = messages[renderJobPK]?.jobMessages;
  let timeoutError = messages[renderJobPK]?.timeoutError;

  useEffect(() => {
    let projectPK = projectMeta.get('projectPK');
    (async () => {
      let response = await queueRendererJob(projectPK, useLogo);
      setRenderJob(response.renderJob);
    })();
  }, []);

  useEffect(() => {
    if (!jobMessages) {
      return;
    }

    let lastMessage = jobMessages[jobMessages.length - 1];
    invariant(lastMessage);
    if (lastMessage.status === 'R') {
      let split = lastMessage.message.split(' ');
      if (split[0] === 'GNRJ' || split[0] === 'about') {
        setDonePercent(0);
      } else {
        setDonePercent(
          Math.trunc((parseInt(split[0]) / parseInt(split[2])) * 100 * 0.8),
        );
      }
    } else if (lastMessage.status === 'A') {
      setDonePercent(85);
    } else if (lastMessage.status === 'processing') {
      setDonePercent(95);
    } else if (lastMessage.status === 'uploaded') {
      setDonePercent(100);
      setAddToCartURL(
        blurbyProjectsBase + `${lastMessage.project_id}/add_to_cart`,
      );
      logCustomEvent('render_upload_complete');
    } else if (isRenderFailed(lastMessage)) {
      emitRenderFailedEvent(
        renderJobPK,
        lastMessage.status,
        lastMessage.message,
      );
    } else if (isUploadFailed(lastMessage)) {
      emitUploadFailedEvent(
        renderJobPK,
        lastMessage.status,
        lastMessage.message,
      );
    }
  }, [jobMessages]);

  function isRenderFailed(lastMessage) {
    return (
      lastMessage.status === 'S' ||
      lastMessage.status === 'X' ||
      lastMessage.status === 'F'
    );
  }

  function isUploadFailed(lastMessage) {
    return (
      lastMessage.status === 'invalid' ||
      lastMessage.status === 'failure' ||
      lastMessage.status === 'purged'
    );
  }

  return (
    <div className={styles.completeProject}>
      <div className={styles.completeProjectStatus}>
        <div className={styles.waitMessage}>
          {t('COMPLETEPROJECT.wait message')}
        </div>
        <ProgressBar
          now={donePercent}
          active={(donePercent !== 100).toString()}
        />
        <div className={styles.percentage}>
          <span>0%</span>
          <span>
            {donePercent}% {t('COMPLETEPROJECT.Complete')}
          </span>
          <span>100%</span>
        </div>
        {timeoutError && (
          <div className={styles.errorMessage}>
            <Trans
              i18nKey="COMPLETEPROJECT.timeout message"
              components={[
                <a
                  href="https://support.blurb.com/hc/en-us/requests/new"
                  target="_blank"
                />,
              ]}
            />
          </div>
        )}
      </div>
      <div className={styles.footer}>
        <PicabooLink onClick={close} linkText={t('COMPLETEPROJECT.Cancel')} />
        <Button
          onClick={() => {
            logCustomEvent('complete_upload');
            window.location = addToCartURL;
          }}
          disabled={!addToCartURL}
        >
          {t('COMPLETEPROJECT.Complete')}
        </Button>
      </div>
    </div>
  );
};

export default connect((state) => ({
  messages: state.messages,
  projectMeta: projectMetadataSelector(state),
}))(CompleteProject);
